import { Box } from '@mui/material';
import { FragmentMediaFiles } from './media/FragmentMediaFiles';
import { FragmentSubtitlesFiles } from './subtitle-status/FragmentSubtitlesFiles';

/**
 * Files tab: media downloads and subtitle downloads as page field groups (no card shells).
 */
export function FragmentFilesView() {
  return (
    <Box sx={{ maxWidth: 'md' }}>
      <FragmentMediaFiles />
      <FragmentSubtitlesFiles />
    </Box>
  );
}
